import Message from "../../message";
import {useMainStore} from "@/store";
import {cleanupStaleNotifications} from "@/services/notificationCleanup";

export default class InviteDeclined extends Message
{
    handle()
    {
        useMainStore().REMOVE_GUILD_INVITE(this.message.user_id);
        cleanupStaleNotifications();
    }
}
